import { clsx, type ClassValue } from 'clsx'
import { cloneElement, isValidElement, ReactElement } from 'react'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const callToActionStyle = cn(
  'cursor-zoom-in hover:bg-zinc-50',
  'transition-[border,background,outline] duration-150 ease-in-out',
  'hover:border-sky-400',
  'outline outline-dashed outline-offset-1 outline-zinc-300/70',
  'outline-sky-400 border-sky-400',
  'hover:outline-solid hover:outline-offset-0 hover:outline-3 hover:outline-sky-400',
)

type IconProps = React.SVGAttributes<SVGElement> & { className?: string }

export function cloneIconElement(icon: ReactElement | null | undefined, props: IconProps = {}): ReactElement | null {
  if (!icon || !isValidElement<{ className?: string }>(icon)) {
    return null
  }

  const { className, ...rest } = props

  return cloneElement(icon, {
    className: cn(className, icon.props.className),
    'aria-hidden': true,
    ...rest,
  } as React.SVGAttributes<SVGElement>)
}
